import { render, staticRenderFns } from "./ModalImage.vue?vue&type=template&id=f1eef1cc&"
import script from "./ModalImage.vue?vue&type=script&lang=ts&"
export * from "./ModalImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AdaptiveImageNew: require('/tmp/build_4600e676/src/components/media/AdaptiveImageNew.vue').default,ModalImageGalleryItem: require('/tmp/build_4600e676/src/components/modal/ImageGallery/Item.vue').default,ModalImageGalleryWrapper: require('/tmp/build_4600e676/src/components/modal/ImageGallery/Wrapper.vue').default})
